import { JSX, useEffect, useState } from "react";
import { wafflesKeyColumnName } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { ContractEntitySpecialtyModel } from "@app/projects/servicing-provider/providerAffiliation";
import { SpecialtyCountModel } from "@app/projects/network-assessment/provider-hub/interfaces";


interface SpecialtyBreakdownAccordionProps {
  specialties: ContractEntitySpecialtyModel[];
  providerHubSpecialties: SpecialtyCountModel[] | undefined;
}

interface SpecialtyBreakdownTableData {
  [wafflesKeyColumnName]: string;
  specialtyName: string;
  specialtyCount: number;
}
  /* oxlint-disable sort-keys */
const SpecialtyBreakdownAccordion = (props: SpecialtyBreakdownAccordionProps): JSX.Element => {
  const [specialtyData, setSpecialtyData] = useState<SpecialtyBreakdownTableData[]>([]);

  useEffect(() => {
    if(props.providerHubSpecialties != undefined){   
      const specialties: SpecialtyBreakdownTableData[] = props.providerHubSpecialties.slice().sort((a, b) => b.count - a.count).map((specialty, index) => {
      return {
        key: index.toString(),
        specialtyName: specialty.name,
        specialtyCount: specialty.count
      }
    })
    setSpecialtyData(specialties);
    }
   else {
    const topFiveSpecialties = props.specialties.sort((a, b) => b.practitionerCount - a.practitionerCount).slice(0, 5);
    const specialties: SpecialtyBreakdownTableData[] = topFiveSpecialties.map((specialty, index) => {
      return {
        key: index.toString(),
        specialtyName: specialty.specialtyName,
        specialtyCount: specialty.practitionerCount
      }
    })
    setSpecialtyData(specialties);
   }
  }, [props.providerHubSpecialties, props.specialties]);

  const columnConfig = ({    
    specialtyName: {
      displayText: "Specialty",
      noResize: true,
      sizeContentToFit: true,
      testId: 'specialty-affiliation'
    },
    specialtyCount: {
      displayText: "Number of Providers",
      noResize: true,
      sizeContentToFit: true,
      testId: 'specialty-count-affiliation',
      hidden: props.providerHubSpecialties === undefined ? true : false
    },    
  });
/* oxlint-enable sort-keys */
  return (
    <>
      <Waffles<SpecialtyBreakdownTableData>
        columns={columnConfig}
        data={specialtyData}
        testId="provider-affiliation-specialtybreakdown-waffles"
        fullWidth={true}
      />
    </>
  )
}

export default SpecialtyBreakdownAccordion;
